<template>
  <div>
    <template>
      <vue-event-calendar :events="events">
        <template slot-scope="props">
          <div
            v-for="(event, index) in props.showEvents"
            :key="index"
            class="event-item"
          >
            <transition name="slide-fade">
              <b-row>
                <b-col sm="4">
                  <div class="calendar-date">
                    <div class="month">
                      {{ eventdateDOW }}
                    </div>
                    <div class="day">
                      {{ eventdateDay }} {{ eventdateMonth }}
                    </div>
                  </div>
                </b-col>
                <b-col sm="8">
                  <div class="event-details">
                    <h3>
                      <generic-link :href="event.path">
                        {{ event.title }}
                      </generic-link>
                    </h3>
                    <p class="location">
                      {{ event.desc }}
                    </p>
                  </div>
                </b-col>
              </b-row>
            </transition>
          </div>
        </template>
      </vue-event-calendar>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import 'vue-event-calendar/dist/style.css'
import dayjs from 'dayjs'
import GenericLink from '../ui-elements/generic-link'
import applogger from '@applogger'
const vueEventCalendar = import('vue-event-calendar')

Vue.use(vueEventCalendar, { locale: 'en', color: '#4d59a1' })

export default {
  components: {
    GenericLink,
    vueEventCalendar
  },
  data() {
    return {
      listItems: {},
      requestType: 'event_list',
      events: []
    }
  },
  computed: {
    eventdateDOW: function() {
      return dayjs(event.date).format('dddd')
    },
    eventdateDay: function() {
      return dayjs(event.date).format('DD')
    },
    eventdateMonth: function() {
      return dayjs(event.date).format('MMM')
    },
    maxItems: function() {
      return this.widgetSettings.maxItems
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    getItems: function() {
      // @todo: ask Phil how to get the events via the Vuex Store
      // Fire Ajax Request
      this.$aspediaLoader
        .getList(this.requestType, 'ajax_response', {
          cache: {
            max_age: 30 * 86400,
            timeout: 30 * 86400,
            scope: 'global',
            cache_keys: {
              type: ['event', 'external_event']
            }
          }
        })
        .then(response => {
          // JSON responses are automatically parsed.
          this.listItems = response.data

          for (const key in this.listItems) {
            this.events.push({
              date: dayjs(
                this.listItems[key].field_d_event_date.value
              ).format('YYYY/MM/DD'),
              title: this.listItems[key].title,
              desc: this.listItems[key].field_t_event_address.name,
              path: this.listItems[key].path,
              type: this.listItems[key].type,
              customClass: 'highlight'
            })
          }
        })
        .catch(e => {
          applogger.error(`Error: ${e.message}`)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

::v-deep  .__vev_calendar-wrapper {
  .cal-events {
    overflow-x: hidden;
    position: absolute;

    .event-item {
      padding: 0;
      background: rgb(77, 89, 161);

      .event-details {
        padding: 10px;

        h3 {
          font-size: 18px;
          line-height: 1.5;
          a {
            color: #fff;
            text-decoration: none;
            transition: ease-in all 0.2s;

            &:hover {
              color: #000;
            }
          }
        }
        p {
          color: rgba(255, 255, 255, 0.55);
          padding: 10px 0;
        }
      }
    }
  }

  .events-wrapper {
    background-color: transparent !important;

    h2.date {
      display: none;
    }
  }

  .cal-wrapper {
    .cal-header {
      .l,
      .r {
        padding: 2px;
        color: #4d59a1;
      }
      .title {
        border: 1px solid #4d59a1;
        color: #4d59a1;
        border-radius: 6px;
        padding: 2px 8px;
      }
    }
  }
}

.calendar-date {
  background-color: rgb(70, 82, 157);
  color: #fff;
  padding: 1em 1.5em;
  text-align: center;
  border-radius: 3px;
  line-height: 1.3;
  height: 100%;

  .month {
    font-size: 1.2em;
  }

  .day {
    font-size: 1.3em;
    color: rgba(255, 255, 255, 0.45);
  }
}
</style>
